"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/render/EventType
 */

/**
 * @enum {string}
 */
var _default = {
  /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */
  PRERENDER: 'prerender',

  /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */
  POSTRENDER: 'postrender',

  /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */
  PRECOMPOSE: 'precompose',

  /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */
  POSTCOMPOSE: 'postcompose',

  /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */
  RENDERCOMPLETE: 'rendercomplete'
};
/**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */

/**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7OztlQUdlO0VBQ2I7Ozs7O0VBS0FBLFNBQVMsRUFBRSxXQU5FOztFQVFiOzs7OztFQUtBQyxVQUFVLEVBQUUsWUFiQzs7RUFlYjs7Ozs7OztFQU9BQyxVQUFVLEVBQUUsWUF0QkM7O0VBd0JiOzs7Ozs7O0VBT0FDLFdBQVcsRUFBRSxhQS9CQTs7RUFpQ2I7Ozs7Ozs7RUFPQUMsY0FBYyxFQUFFO0FBeENILEM7QUEyQ2Y7Ozs7QUFJQSIsIm5hbWVzIjpbIlBSRVJFTkRFUiIsIlBPU1RSRU5ERVIiLCJQUkVDT01QT1NFIiwiUE9TVENPTVBPU0UiLCJSRU5ERVJDT01QTEVURSJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvcmVuZGVyL0V2ZW50VHlwZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==